import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textsearch',
    standalone: false
})
export class TextsearchPipe implements PipeTransform {

  transform(reqValArr: any, args: any[], field: string): unknown {
    if (args != null && args.length >= 1) {
      return reqValArr.filter(item => item[field].toLowerCase().indexOf(args[0].toLowerCase()) !== -1);
    }
    return reqValArr;

  }

}
